<template>
	<div :class="'freeUserTips free-usertips-bg'+bgtype" >
		<div class="freeUserTips-opbg">
			<div class="freeUserTips-con"> 
				<h5 class="title tac orangefont fz24 lh48 mt-2">温馨提示</h5>
				<p class="tac fz16 lh28 orangefont" v-if="type == 1">您的试用时间已到期，如需延期请即刻与我们联系<br> 升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 2">升级为正式账号，即可享受完整权益</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 3">成为SVIP， 即可享受产业链分析报告下载功能</p>
				<p class="tac fz16 lh28 orangefont" v-if="type == 4">开通VIP，即可享受完整权益</p>

				<!-- 请 <a class="curp" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
						target="_blank">在线咨询 ></a> ，或微信咨询： -->
				<div class="right-slide-wechat mga por mt-2" v-if="userdata.wx_image == ''">
					<div class="wechatfont">扫一扫 加微信咨询我们</div>
					<div class="wechat_codebox fl">
						<img src="../../assets/images/zixuncode-lss.png">
						<p class="tac">中投顾问 - 刘姗姗</p>
					</div>
					<div class="wechat_codebox fr">
						<img src="../../assets/images/zixuncode-bl.png">
						<p class="tac">中投顾问 - 白灵</p>
					</div>
				</div>
				<!-- wx_image为空展示双二维码，否则展示单个二维码 -->
				<div class="right-slide-wechat mga por mt-2 single-wechat" v-else>
					<div class="wechatfont">扫一扫 加微信咨询我们</div>
					<div class="wechat_codebox fl">
						<img :src="userdata.wx_image">
						<p class="tac">中投顾问 - {{userdata.wx_name}}</p>
					</div>
				</div>
				<p class="tac fz16 orangefont mt-2">联系电话:400 008 0586&nbsp;&nbsp;&nbsp;&nbsp;0755-82571568</p>
				<p class="tac mt-1 download-text fz16" v-show="isShowDownFile">点击下载：<a class="fz16 basefont" href="https://lian.ocn.com.cn/upload/pdf/202403/291129249208772.docx" target="downloadFile" download>新能源汽车产业链分析报告 ></a></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'userlogin',
		props: {
			type: {
				type: Number,
				default: 1, //1试用账号 2免费账号 3正式账号但无操作权限
			},
			bgtype: {
				type: Number,
				default: 1, 
				/*1为企业详情页供应商客户表格背景 2为拿地信息表格 3投资项目表格 4融资项目 5.对外投资 6.控制企业 7.专利信息8.软件著作权9.资质证书 10裁判文书 11司法案件 
				14为白色背景15.以商招商列表页 16.企业-城市关系计算器（本地关联企业）列表 17.企业-城市关系计算器（一级关系圈）列表 18.企业-城市关系计算器（二级关系圈计算结果）列表
				19.协会 20.商会 21.专业镇 22.股东信息 23.企业详情的相同投资机构 24.相同协会 25.相同商会 26.本地投资趋势 27.外商投资趋势
				*/
			},
			isShowDownFile: {  //是否显示下载模板链接
				type: Boolean,
				default: false,
			},
		 
		},
		data() {
			return {
				userdata:{},
			}
		},
		created() { 
			this.userdata = this.getuseriformation();	
		},
	}
</script>

<style>
	.download-text{
		color: #3A66BE;
	}
	.download-text a{
		text-decoration: underline;
	}
	.freeUserTips {
		width: 100%;
		height: 450px;
	} 
	/*free-usertips-bg 在leftnav.less 搜索free-usertips-bg*/
	.freeUserTips-opbg {
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, .8);
		overflow: hidden;
	}
	.freeUserTips-con{
		width: 640px;height: 410px;margin:20px auto;
		background: #fff6e4;
		border: 4px solid #f2c86f;overflow: hidden;
	}
</style>